import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  FIELDS_TO_VALIDATE as SCHEDULE_FIELDS_TO_VALIDATE,
  INITIAL_VALUES as SCHEDULE_INITIAL_VALUES,
} from '../common/Scheduling/fieldset'

export const STEP_KEYS = {
  DELETE_USER: 'DELETE_USER',
  OPTIONAL_SETTINGS: 'OPTIONAL_SETTINGS',
  REVIEW: 'REVIEW',
  SUBMIT: 'SUBMIT',
}

export const MODAL_STEPS = [
  {
    label: <FormattedMessage id="ENGAGE.OFFBOARD.DELETE_USER" />,
    key: STEP_KEYS.DELETE_USER,
  },
  {
    label: <FormattedMessage id="GENERAL.OPTIONAL_SETTINGS" />,
    key: STEP_KEYS.OPTIONAL_SETTINGS,
  },
  {
    label: <FormattedMessage id="GENERAL.REVIEW_AND_FINISH" />,
    key: STEP_KEYS.REVIEW,
  },
  {
    label: null,
    key: STEP_KEYS.SUBMIT,
  },
]

// do not forget to add new fields to initial values below and to the utils functions (validate, buildInitialValues) in this folder
export const FORM_FIELDS = {
  // email section
  REMOVE_EMAIL_ALIASES: 'removeEmailAliases',
  REMOVE_DELEGATE_PERMISSIONS: 'removeDelegatePermissions',
  IS_FOWARDING_MAILBOX: 'isForwardingMailbox',
  FORWARD_MAILBOX_TO: 'forwardMailboxTo',
  HIDDEN_FROM_ADDRESS_LIST_ENABLED: 'hiddenFromAddressListEnabled',

  // shared mailbox section
  CONVERT_TO_SHARED_MAILBOX: 'convertToSharedMailbox',
  MAILBOX_USERS: 'mailboxUsers',

  // auto reply section
  SEND_AUTOMATIC_REPLIES: 'sendAutomaticReplies',
  SEND_REPLIES_DURING_PERIOD: 'sendRepliesDuringPeriod',
  AUTO_REPLY_START_DATE: 'autoReplyStartDate',
  AUTO_REPLY_END_DATE: 'autoReplyEndDate',
  INTERNAL_REPLY_MESSAGE: 'internalReplyMessage',
  EXTERNAL_REPLY_MESSAGE: 'externalReplyMessage',

  // security actions section
  RESET_PASSWORD: 'resetPassword',
  REVOKE_SESSIONS: 'revokeSessions',
  DISABLE_USER: 'disableUser',

  // remove from groups
  REMOVE_FROM_M365_GROUPS: 'removeFromM365Groups',
  REMOVE_FROM_SECURITY_GROUPS: 'removeFromSecurityGroups',
  REMOVE_FROM_DISTRIBUTION_GROUPS: 'removeFromDistributionGroups',
  REMOVE_FROM_SHARED_MAILBOXES: 'removeFromSharedMailboxes',
}

export const INITIAL_VALUES = {
  // schedule section
  ...SCHEDULE_INITIAL_VALUES,

  // email section
  [FORM_FIELDS.REMOVE_EMAIL_ALIASES]: true,
  [FORM_FIELDS.REMOVE_DELEGATE_PERMISSIONS]: true,
  [FORM_FIELDS.IS_FOWARDING_MAILBOX]: false,
  [FORM_FIELDS.FORWARD_MAILBOX_TO]: null,
  [FORM_FIELDS.HIDDEN_FROM_ADDRESS_LIST_ENABLED]: true,

  // shared mailbox section
  [FORM_FIELDS.CONVERT_TO_SHARED_MAILBOX]: true,
  [FORM_FIELDS.MAILBOX_USERS]: [],

  // auto reply section
  [FORM_FIELDS.SEND_AUTOMATIC_REPLIES]: false,
  [FORM_FIELDS.SEND_REPLIES_DURING_PERIOD]: false,
  [FORM_FIELDS.AUTO_REPLY_START_DATE]: '',
  [FORM_FIELDS.AUTO_REPLY_END_DATE]: '',
  [FORM_FIELDS.INTERNAL_REPLY_MESSAGE]: '',
  [FORM_FIELDS.EXTERNAL_REPLY_MESSAGE]: '',

  // security actions section
  [FORM_FIELDS.RESET_PASSWORD]: true,
  [FORM_FIELDS.REVOKE_SESSIONS]: true,
  [FORM_FIELDS.DISABLE_USER]: true,

  // remove from groups
  [FORM_FIELDS.REMOVE_FROM_M365_GROUPS]: [],
  [FORM_FIELDS.REMOVE_FROM_SECURITY_GROUPS]: [],
  [FORM_FIELDS.REMOVE_FROM_DISTRIBUTION_GROUPS]: [],
  [FORM_FIELDS.REMOVE_FROM_SHARED_MAILBOXES]: [],
}

// we need to know what fields we have in the first panel to validate them before going to the next panel
export const DELETE_USER_PANEL_FIELDS = {
  // schedule section
  ...SCHEDULE_FIELDS_TO_VALIDATE,

  // email section
  [FORM_FIELDS.REMOVE_EMAIL_ALIASES]: true,
  [FORM_FIELDS.REMOVE_DELEGATE_PERMISSIONS]: true,
  [FORM_FIELDS.IS_FOWARDING_MAILBOX]: true,
  [FORM_FIELDS.FORWARD_MAILBOX_TO]: true,
  [FORM_FIELDS.HIDDEN_FROM_ADDRESS_LIST_ENABLED]: true,
  // shared mailbox section
  [FORM_FIELDS.CONVERT_TO_SHARED_MAILBOX]: true,
  [FORM_FIELDS.MAILBOX_USERS]: true,
  // auto reply section
  [FORM_FIELDS.SEND_AUTOMATIC_REPLIES]: true,
  [FORM_FIELDS.SEND_REPLIES_DURING_PERIOD]: true,
  [FORM_FIELDS.AUTO_REPLY_START_DATE]: true,
  [FORM_FIELDS.AUTO_REPLY_END_DATE]: true,
  [FORM_FIELDS.INTERNAL_REPLY_MESSAGE]: true,
  [FORM_FIELDS.EXTERNAL_REPLY_MESSAGE]: true,
}
